import { render, staticRenderFns } from "./IntegratedDosingSystem.vue?vue&type=template&id=42e48314&"
import script from "./IntegratedDosingSystem.vue?vue&type=script&lang=js&"
export * from "./IntegratedDosingSystem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports